import { useEffect, useState } from 'react';

// Filtro que sobrevive à navegação: o valor fica em sessionStorage (por aba do navegador),
// então trocar de tela/menu e voltar mantém a seleção; fechar a aba limpa tudo.
// Leitura e gravação protegidas por try/catch: sem storage (janela privada, storage bloqueado)
// vira um useState comum.
export default function useFiltroLembrado(chave, inicial) {
  const [valor, setValor] = useState(() => {
    try {
      const guardado = window.sessionStorage.getItem(chave);
      return guardado === null ? inicial : JSON.parse(guardado);
    } catch {
      return inicial;
    }
  });
  useEffect(() => {
    try {
      window.sessionStorage.setItem(chave, JSON.stringify(valor));
    } catch { /* sem storage: segue só em memória */ }
  }, [chave, valor]);
  return [valor, setValor];
}
